export function arrayMoveItem(arr, from, to) {
    arr.splice(to, 0, arr.splice(from, 1)[0]);
}
export function arraySwapItem(arr, x, y) {
    const b = arr[x];
    arr[x] = arr[y];
    arr[y] = b;
    return arr;
}
export function getValue(val, lang = "en") {
    if (val == null)
        return val;
    if (typeof val === "string")
        return val;
    if (typeof val === "object" && !Array.isArray(val)) {
        if (val[lang])
            return val[lang];
        return Object.values(val)[0];
    }
    return val;
}
export function normalizeObject(obj, lang = "en") {
    if (Array.isArray(obj)) {
        return obj.map(v => normalizeObject(v, lang));
    }
    if (obj && typeof obj === "object") {
        const out = {};
        for (const key in obj) {
            let newKey = key === "_id" && obj.id == null ? "id" : key;
            const val = obj[key];
            if (typeof val === "object") {
                out[newKey] = getValue(val, lang);
                if (typeof out[newKey] === "object") {
                    out[newKey] = normalizeObject(val, lang);
                }
            }
            else {
                out[newKey] = val;
            }
        }
        return out;
    }
    return obj;
}
export function restoreLegacyIdsDeep(value) {
    if (Array.isArray(value)) {
        return value.map(restoreLegacyIdsDeep);
    }
    if (value && typeof value === "object") {
        const out = {};
        for (const key in value) {
            const newKey = key === "id" && value._id == null ? "_id" : key;
            out[newKey] = restoreLegacyIdsDeep(value[key]);
        }
        return out;
    }
    return value;
}
export function getId(obj) {
    if (!obj)
        return undefined;
    return obj.id ?? obj._id;
}
//# sourceMappingURL=functions.js.map